import React from "react";
import { Grid, makeStyles, Typography } from "@material-ui/core";
import Controls from "../controls/Controls";

const useStyles = makeStyles(() => ({
  gridItemLeft: {
    display: "flex",
    alignItems: "center",
  },

  gridItemRight: {
    display: "flex",
    flexDirection: "row",
    justifyContent: "flex-end",
  },

  description: {
    fontSize: "1em",
    color: "#8F9194",
    fontWeight: 100,
    fontFamily: "Inter",
  },
}));

interface IButtonsProps {
  onBackClick?: () => void;
  onNextClick?: () => void;
  onFinishClick?: () => void;
  currentStep: number;
  isLoading: boolean;
  totalSteps: number;
}

export default function StepButtons(props: IButtonsProps) {
  const classes = useStyles();

  return (
    <Grid container spacing={2}>
      <Grid item xs={5}>
        <Typography className={classes.description}>
          As informações inseridas são salvas automaticamente
        </Typography>
      </Grid>
      <Grid item xs={7} className={classes.gridItemRight}>
        <Controls.Button
          text="Voltar"
          type="Back"
          isLoading={props.isLoading}
          onClick={props.onBackClick}
        />

        {props.currentStep !== props.totalSteps ? (
          <Controls.Button
            text="Avançar"
            type="Next"
            isLoading={props.isLoading}
            onClick={props.onNextClick}
          />
        ) : (
          <Controls.Button
            text="Finalizar"
            type="Next"
            isLoading={props.isLoading}
            onClick={props.onFinishClick}
          />
        )}
      </Grid>
    </Grid>
  );
}
